import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InfoCallout({ children }) {
  return (
    <div className="flex flex-row items-center gap-2 bg-brand-subtle p-3 rounded-xl my-2 text-brand">
      <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
      <span className="text-sm">{children}</span>
    </div>
  );
}
